import React from "react";
import MenuComponent from "../../components/MenuComponent/MenuComponent";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import EditLogo from "../../Assets/editLogo.png";
import DeleteIcon from "../../Assets/delete_icon.png";
import CloseLogo from "../../Assets/close_icon.png";
import { useListVendor } from "./useListVendor";
import "./ListVendor.css";

const ListVendor = () => {
  const {
    dataUser,
    menu,
    setMenu,
    listVendor,
    popUpNewVendor,
    setPopUpNewVendor,
    popUpEditVendor,
    setPopUpEditVendor,
    nameNewVendor,
    setNameNewVendor,
    tlpNewVendor,
    setTlpNewVendor,
    faxNewVendor,
    setFaxNewVendor,
    npwpNewVendor,
    setNpwpNewVendor,
    emailNewVendor,
    setEmailNewVendor,
    alamatNewVendor,
    setAlamatNewVendor,
    attnNewVendor,
    setAttnNewVendor,
    isDisabled,
    setIsDisabled,
    handleKirimNewVendor,
    pickEdit,
    setPickEdit,
    handleChangeEdit,
    handleKirimEdit,
    handleDelete,
    popUpImportListVendor,
    setPopUpImportListVendor,
    setFile,
    handleBulkImportList,
    handleExportTemplate,
  } = useListVendor();
  return (
    <>
      {popUpImportListVendor ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div className="popup-header">
            <button
              className="button-create-po"
              style={{ background: "green" }}
              onClick={() => {
                handleExportTemplate();
              }}
            >
              Download Template
            </button>

            <img
              className="img-close-popup-bpb"
              src={CloseLogo}
              onClick={() => {
                setPopUpImportListVendor(false);
              }}
              alt="edit_logo"
            />
          </div>
          <div className="popup-header">
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setFile(e.target.files[0])}
              style={{ cursor: "pointer" }}
            />
            <button
              className="button-create-po"
              style={{ background: "red" }}
              onClick={() => {
                handleBulkImportList();
              }}
            >
              Kirim
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpNewVendor ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div className="popup-content">
            <div className="popup-header">
              <h2 className="popup-title">Tambah Vendor</h2>

              <img
                className="img-close-popup-bpb"
                src={CloseLogo}
                onClick={() => {
                  setPopUpNewVendor(false);
                  setAlamatNewVendor();
                  setEmailNewVendor();
                  setNpwpNewVendor();
                  setFaxNewVendor();
                  setTlpNewVendor();
                  setNameNewVendor();
                  setAttnNewVendor();
                }}
                alt="edit_logo"
              />
            </div>

            <div className="popup-form">
              <div className="popup-row">
                <p className="popup-label">Nama Vendor</p>

                <input
                  className="popup-input"
                  value={nameNewVendor}
                  onChange={(e) =>
                    setNameNewVendor(e.target.value.toUpperCase())
                  }
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">Tlp</p>

                <input
                  className="popup-input"
                  value={tlpNewVendor}
                  onChange={(e) =>
                    setTlpNewVendor(e.target.value.toUpperCase())
                  }
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">Fax</p>

                <input
                  className="popup-input"
                  value={faxNewVendor}
                  onChange={(e) =>
                    setFaxNewVendor(e.target.value.toUpperCase())
                  }
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">NPWP</p>

                <input
                  className="popup-input"
                  value={npwpNewVendor}
                  onChange={(e) =>
                    setNpwpNewVendor(e.target.value.toUpperCase())
                  }
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">Email</p>

                <input
                  className="popup-input"
                  value={emailNewVendor}
                  onChange={(e) => setEmailNewVendor(e.target.value)}
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">Attn</p>

                <input
                  className="popup-input"
                  value={attnNewVendor}
                  onChange={(e) => setAttnNewVendor(e.target.value)}
                />
              </div>

              <div className="popup-row popup-row-textarea">
                <p className="popup-label">Alamat</p>

                <textarea
                  className="popup-textarea"
                  value={alamatNewVendor}
                  onChange={(e) =>
                    setAlamatNewVendor(e.target.value.toUpperCase())
                  }
                />
              </div>
            </div>

            <div className="popup-footer">
              <button
                className="button-create-po"
                disabled={isDisabled}
                onClick={() => {
                  setIsDisabled(true);
                  handleKirimNewVendor();
                }}
              >
                Kirim
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}

      {popUpEditVendor ? (
        <PopUpComponent
          style={{
            marginTop: "calc(100vh - 95vh - 20px)",
            overflowY: "scroll",
            padding: "12px",
          }}
        >
          <div className="popup-content">
            <div className="popup-header">
              <h2 className="popup-title">Edit Vendor</h2>

              <img
                className="img-close-popup-bpb"
                src={CloseLogo}
                onClick={() => {
                  setPickEdit();
                  setPopUpEditVendor(false);
                }}
                alt="edit_logo"
              />
            </div>

            <div className="popup-form">
              <div className="popup-row">
                <p className="popup-label">Nama Vendor</p>

                <input
                  className="popup-input"
                  value={pickEdit?.name || ""}
                  name="name"
                  onChange={(e) => handleChangeEdit(e)}
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">Tlp</p>

                <input
                  className="popup-input"
                  value={pickEdit?.tlp || ""}
                  name="tlp"
                  onChange={(e) => handleChangeEdit(e)}
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">Fax</p>

                <input
                  className="popup-input"
                  value={pickEdit?.fax || ""}
                  name="fax"
                  onChange={(e) => handleChangeEdit(e)}
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">NPWP</p>

                <input
                  className="popup-input"
                  value={pickEdit?.npwp || ""}
                  name="npwp"
                  onChange={(e) => handleChangeEdit(e)}
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">Email</p>

                <input
                  className="popup-input"
                  value={pickEdit?.email || ""}
                  name="email"
                  onChange={(e) => handleChangeEdit(e)}
                />
              </div>

              <div className="popup-row">
                <p className="popup-label">Attn</p>

                <input
                  className="popup-input"
                  value={pickEdit?.attn || ""}
                  name="attn"
                  onChange={(e) => handleChangeEdit(e)}
                />
              </div>

              <div className="popup-row popup-row-textarea">
                <p className="popup-label">Alamat</p>

                <textarea
                  className="popup-textarea"
                  value={pickEdit?.alamat || ""}
                  name="alamat"
                  onChange={(e) => handleChangeEdit(e)}
                />
              </div>
            </div>

            <div className="popup-footer">
              <button
                className="button-create-po"
                disabled={isDisabled}
                onClick={() => {
                  setIsDisabled(true);
                  handleKirimEdit();
                }}
              >
                Kirim
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {dataUser !== null ? <MenuComponent setMenu={setMenu} menu={menu} /> : ""}
      <div className="container-inventory">
        <div className="wrapper-inventory">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button
              className="button-create-po"
              style={{ background: "#fe8c50" }}
              onClick={() => {
                setPopUpImportListVendor(true);
              }}
            >
              Import Vendor
            </button>
            <button
              className="button-create-po"
              style={{ backgroundColor: "green" }}
              onClick={() => {
                setPopUpNewVendor(true);
              }}
            >
              + New Vendor
            </button>
          </div>
          <br />
          <div className="wrapper-table">
            <table className="font10-mobile-bpb table-List-vendor">
              <tr>
                <th
                  style={{
                    padding: "12px 8px",
                    width: "8%",
                  }}
                >
                  No.
                </th>
                <th style={{ padding: "12px 8px" }}>Nama Vendor</th>
                <th style={{ padding: "12px 8px" }}>Alamat</th>
                <th style={{ padding: "12px 8px" }}>Tlp</th>
                <th style={{ padding: "12px 8px" }}>Fax</th>
                <th style={{ padding: "12px 8px" }}>N.P.W.P</th>
                <th style={{ padding: "12px 8px" }}>Email</th>
                <th style={{ padding: "12px 8px" }}>Attn</th>
                <th></th>
                <th></th>
              </tr>
              {listVendor &&
                listVendor.map((ele, index) => {
                  return (
                    <tr
                      style={
                        index % 2 === 0
                          ? { background: "white" }
                          : { background: "#F7F7F7" }
                      }
                    >
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                        }}
                      >
                        {index + 1}.
                      </td>
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {ele?.name || ""}
                      </td>
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                        }}
                      >
                        {ele?.alamat || ""}
                      </td>
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {ele?.tlp || ""}
                      </td>
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {ele?.fax || ""}
                      </td>
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {ele?.npwp || ""}
                      </td>
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {ele?.email || ""}
                      </td>
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {ele?.attn || ""}
                      </td>
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                        }}
                      >
                        <img
                          className="width_edit_logo"
                          src={EditLogo}
                          onClick={() => {
                            setPickEdit(ele);
                            setPopUpEditVendor(true);
                          }}
                          alt="edit_logo"
                        />
                      </td>
                      <td
                        style={{
                          padding: "12px 6px 12px 6px",
                        }}
                      >
                        <img
                          className="img-delete-bpb"
                          src={DeleteIcon}
                          onClick={() => {
                            handleDelete(ele.id);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              <tr></tr>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
export default ListVendor;
